
export default {

    set_loading(state, value) {
        state.loading=value
    },

    set_list(state, value) {
        state.list=value
    },

    set_empty_box(state, value) {
        state.emptyBox=value
    }
}